import { PaginaOperaciones } from '../components/PaginaOperaciones'
import type { Entrega } from '../types'

export default function Transporte() {
  return (
    <PaginaOperaciones<Entrega>
      titulo="Transporte"
      recurso="transporte"
      llave="id"
      columnas={[
        { campo: 'folio', titulo: 'Folio' },
        { campo: 'rutaFolio', titulo: 'Ruta' },
        { campo: 'clienteNombre', titulo: 'Cliente' },
        { campo: 'direccion', titulo: 'Direccion', render: (e) => e.direccion || '-' },
        { campo: 'estado', titulo: 'Estado' },
        { campo: 'fecha', titulo: 'Fecha', render: (e) => e.fecha?.split('T')[0] || '-' },
      ]}
      campos={[]}
      valorInicial={{}}
      puedeCrear={false}
      acciones={[
        {
          label: 'Confirmar',
          endpoint: (e) => `transporte/${e.id}/estado`,
          body: (e) => ({ id: e.id, estado: 'Entregado' }),
          metodo: 'PUT'
        },
        {
          label: 'Incidente',
          endpoint: (e) => `transporte/${e.id}/estado`,
          body: (e) => ({ id: e.id, estado: 'Incidente', incidente: e.incidente }),
          metodo: 'PUT'
        }
      ]}
    />
  )
}
